export default {
      id: "icon--my-account-usage",
      viewBox: "0 0 31 31",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--my-account-usage",
      toString: function () {
        return this.url;
      }
    }